import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { MONTHS } from "@/components/previsionale/helpers";
import { ClipboardCheck, ArrowRight } from "lucide-react";

export default function ExpensesReminder() {
  const { isSuperAdmin: isAdmin } = useAuth();
  const [months, setMonths] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (!isAdmin) return;
    api.get("/spese-da-confermare/promemoria").then((r) => setMonths(r.data.months)).catch(() => {});
  }, [isAdmin]);
  if (!months.length) return null;
  const txt = months.map((m) => `${m.pending} voci per ${MONTHS[Number(m.month.slice(5)) - 1]} ${m.month.slice(0, 4)}`).join(" · ");
  return (
    <button data-testid="expenses-reminder" onClick={() => navigate("/previsionale")}
      className="mb-6 w-full text-left flex flex-wrap items-center gap-2 text-sm rounded-md border border-amber-200 bg-amber-50 text-amber-800 px-3 py-2.5 hover:bg-amber-100 transition-colors">
      <ClipboardCheck size={16} />
      <span><b>Spese da confermare:</b> {txt}.</span>
      <span className="ml-auto inline-flex items-center gap-1 font-semibold">Conferma nel Previsionale <ArrowRight size={14} /></span>
    </button>
  );
}
